import type { IInstalledApp } from '@/entities/client.entity';
import { cn } from '@/lib/utils';

interface ClientAppCardProps {
	app: IInstalledApp;
	onCopy: (text: string) => void;
	className?: string;
}

export default function ClientAppCard({ app, onCopy, className }: ClientAppCardProps) {
	return (
		<button
			type='button'
			className={cn('w-full min-w-0 text-left rounded-md px-2 py-1.5 hover:bg-accent/50 transition-colors', className)}
			onClick={() => onCopy(app.packageName)}
		>
			<p className='text-sm font-medium truncate'>{app.label}</p>
			<p className='text-xs text-muted-foreground break-all leading-tight'>{app.packageName}</p>
		</button>
	);
}
